import React from 'react'
import { EditTwoTone, EyeFilled, InfoCircleOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Row,
  Col,
  Button,
  Select,
  Table,
  Tooltip,
  DatePicker,
} from "antd";
import { ColumnsType } from "antd/es/table";
import { EmployeesNICategory, EmployeesNICategoryList, INIRates } from "../../Services/PayrollYearlySettingsService";
import dayjs, { Dayjs } from "dayjs";
import Link from "antd/es/typography/Link";
import CustomRangePicker from '../../Common/Custom Components/Ant design/RangePicker';

interface iNIRatesProps {
  isViewOnly: boolean;
  OnCancelClick: () => void;
  setDialog: React.Dispatch<
    React.SetStateAction<{
      type: string;
      params: any;
    }>
  >;
  NIRatesList: INIRates[] | [];
}

const NIRates = ({
  isViewOnly = false,
  OnCancelClick,
  setDialog,
  NIRatesList,
}: iNIRatesProps) => {
  const [niRatesListData, setNIRatesListData] = React.useState<INIRates[]>(NIRatesList || []);
  // console.log("NIRatesList", NIRatesList, "niRatesListData", niRatesListData);
  const [params, setParams] = React.useState<{
    niCategory: EmployeesNICategory[],
    isAM: number,
    fromDate: Dayjs | null,
    toDate: Dayjs | null
  }
  >({
    niCategory: [],
    isAM: 0,
    fromDate: null,
    toDate: null,
  })
  const [pagination, setPagination] = React.useState({
    current: 1,
    pageSize: 15,
  });

  const columns: ColumnsType<INIRates> = [
    {
      title: "S.No",
      dataIndex: "sno",
      key: "sno",
      width: "4%",
      render: (_: any, record: any, index: any) => <p>{(pagination.current - 1) * pagination.pageSize + index + 1}</p>,
    },
    {
      title: "NICategory",
      dataIndex: "niCategory",
      key: "NICategory",
      width: "5%",
      render: (_: any, record: any, index: any) => <p>{EmployeesNICategory[record?.niCategory]}</p>
    },
    {
      title: "Annual Method",
      dataIndex: "isAM",
      key: "IsAM",
      width: "8%",
      render: (_: any, record: any, index: any) => <>{record?.isAM ? "Yes" : "No"}</>
    },
    {
      title: "PayDate From",
      dataIndex: "payDateFrom",
      key: "PayDateFrom",
      width: "8%",
      render: (_: any, record: any, index: any) => <>{record?.payDateFrom ? dayjs(record?.payDateFrom).format("DD/MM/YYYY") : '-'}</>,
      sorter: (a: any, b: any) => dayjs(a.payDateFrom).unix() - dayjs(b.payDateFrom).unix(),
    },
    {
      title: "PayDate To",
      dataIndex: "payDateTo",
      key: "PayDateTo",
      width: "8%",
      render: (_: any, record: any, index: any) => <>{record?.payDateTo ? dayjs(record?.payDateTo).format("DD/MM/YYYY") : '-'}</>,
      sorter: (a: any, b: any) => dayjs(a.payDateTo).unix() - dayjs(b.payDateTo).unix(),
    },
    {
      title: "EE Rate LEL",
      dataIndex: "eeRateLEL",
      key: "EERateLEL",
      width: "6%",
      sorter: (a: any, b: any) => a.eeRateLEL - b.eeRateLEL,
    },
    {
      title: "EE Rate UEL",
      dataIndex: "eeRateUEL",
      key: "EERateUEL",
      width: "6%",
      sorter: (a: any, b: any) => a.eeRateUEL - b.eeRateUEL,
    },
    {
      title: "EE Rate AUEL",
      dataIndex: "eeRateAUEL",
      key: "AUEL",
      width: "6%",
      sorter: (a: any, b: any) => a.eeRateAUEL - b.eeRateAUEL,
    },
    {
      title: "EE Rate PT",
      dataIndex: "eeRatePT",
      key: "EERatePT",
      width: "6%",
      sorter: (a: any, b: any) => a.eeRatePT - b.eeRatePT,
    },
    {
      title: "EE Rate UST",
      dataIndex: "eeRateUST",
      key: "EERateUST",
      width: "6%",
      sorter: (a: any, b: any) => a.eeRateUST - b.eeRateUST,
    },
    // {
    //   title: "EE Rate AUST",
    //   dataIndex: "eeRateAUST",
    //   key: "EERateAUST",
    //   width: "5%",
    // },
    // {
    //   title: "EE Rate FUST",
    //   dataIndex: "eeRateFUST",
    //   key: "EERateFUST",
    //   width: "5%",
    // },
    // {
    //   title: "EE Rate VUST",
    //   dataIndex: "eeRateVUST",
    //   key: "EERateVUST",
    //   width: "5%",
    // },
    {
      title: "ER Rate ST",
      dataIndex: "erRateST",
      key: "ERRateST",
      width: "6%",
      sorter: (a: any, b: any) => a.erRateST - b.erRateST,
    },
    {
      title: "ER Rate UST",
      dataIndex: "erRateUST",
      key: "ERRateUST",
      width: "6%",
      sorter: (a: any, b: any) => a.erRateUST - b.erRateUST,
    },
    // {
    //   title: "ER Rate FUST",
    //   dataIndex: "erRateFUST",
    //   key: "ERRateFUST",
    //   width: "5%",
    // },
    // {
    //   title: "ER Rate AUST",
    //   dataIndex: "erRateAUST",
    //   key: "ERRateAUST",
    //   width: "5%",
    // },
    // {
    //   title: "ER Rate VUST",
    //   dataIndex: "erRateVUST",
    //   key: "ERRateVUST",
    //   width: "5%",
    // },
    {
      title: "ER Rate UEL",
      dataIndex: "erRateUEL",
      key: "ERRateUEL",
      width: "6%",
      sorter: (a: any, b: any) => a.erRateUEL - b.erRateUEL,
    },
    {
      title: "ER Rate AUEL",
      dataIndex: "erRateAUEL",
      key: "ERRateAUEL",
      width: "6%",
      sorter: (a: any, b: any) => a.erRateAUEL - b.erRateAUEL,
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "Id",
      width: "3%",
      render: (_: any, record: any, index: any) => (
        <Link
          className="edit-btn"
          onClick={() => {
            setDialog({ type: "AddNIRate", params: { record: record } });
          }}
        >
          {
            isViewOnly ?
              <EyeFilled />
              :
              <EditTwoTone />
          }
        </Link>
      ),
    },
  ];

  React.useEffect(() => {
    if (NIRatesList?.length > 0) {
      // setLoading(true);

      let lst: INIRates[] = NIRatesList;

      const hasPayFreq =
        Array.isArray(params.niCategory) &&
        params.niCategory?.length > 0;

      const hasDateRange = params.fromDate && params.toDate;

      lst = lst.filter((ni: any) => {

        /* -------- isAM Filter -------- */
        let isAM = true;
        if (params.isAM === 1) isAM = ni.isAM === true;
        else if (params.isAM === 2) isAM = ni.isAM === false || ni.isAM === null;

        /* -------- NI Category Filter -------- */
        const payFreqMatch = hasPayFreq
          ? params.niCategory?.includes(ni.niCategory)
          : true;

        /* -------- Date Range Filter -------- */
        let dateMatch = true;
        if (hasDateRange) {
          const recordFrom = dayjs(ni.payDateFrom);
          const recordTo = dayjs(ni.payDateTo);

          dateMatch =
            recordFrom.isSameOrBefore(params.toDate, "day") &&
            recordTo.isSameOrAfter(params.fromDate, "day");
        }

        return isAM && payFreqMatch && dateMatch;
      });

      console.log("Filtered List", lst);
      setNIRatesListData(lst);
      // setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, NIRatesList]);

  return (
    <>
      <Row
        className="p-3"
        style={{
          backgroundColor: "white",
          paddingTop: 2,
        }}
      >
        <Col span={24}>
          <Row gutter={[8, 8]} className="pb-3"
            align="middle">
            {/* ================= ADD ================= */}
            <Col xs={24} sm={12} md={5} lg={5} xl={4} xxl={3}>
              {
                !isViewOnly ?
                  <Button
                    type="primary"
                    className="add-btn"
                    onClick={() => setDialog({ type: "AddNIRate", params: {} })}
                    block
                  >
                    <PlusOutlined />
                    Add NI Rate
                  </Button>
                  : null
              }
            </Col>
            {/* ================= DATE ================= */}
            <Col xs={24} sm={12} md={{ span: 8, offset: 0 }} lg={{ span: 6, offset: 3 }} xl={{ span: 5, offset: 6 }} xxl={{ span: 4, offset: 10 }}>
              <CustomRangePicker
                value={[params.fromDate, params.toDate]}
                onChange={(dates) => {
                  setParams((prev) => ({
                    ...prev,
                    fromDate: dates?.[0] || null,
                    toDate: dates?.[1] || null,
                  }));
                }}
              />
            </Col>
            {/* ================= NICategory List ================= */}
            <Col xs={24} sm={12} md={6} lg={6} xl={5} xxl={4}>
              <Select
                mode="multiple"
                maxTagCount="responsive"
                style={{ width: "100%" }}
                placeholder="Select NI Category"
                showSearch
                allowClear
                optionFilterProp="label"
                options={EmployeesNICategoryList}
                onChange={(val) => setParams({ ...params, niCategory: val })}
                optionRender={(option: any) => {
                  const tooltip = option.data?.tooltip;

                  return (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <span>{option.label}</span>
                      {tooltip &&
                        <Tooltip title={tooltip}>
                          <InfoCircleOutlined
                            aria-label="info-circle"
                          // onClick={(e) => e.stopPropagation()}
                          />
                        </Tooltip>
                      }
                    </div>
                  );
                }}
              />
            </Col>
            {/* ================= STATUS ================= */}
            <Col xs={24} sm={12} md={5} lg={4} xl={4} xxl={3}>
              <Select
                className="me-3 line-height-28"
                style={{
                  width: "100%"
                }}
                placeholder="Annual Method Exist"
                options={[
                  { value: 0, label: "All Annual Method" },
                  { value: 1, label: "Yes Annual Method" },
                  { value: 2, label: "No Annual Method" },
                ]}
                value={params?.isAM}
                onChange={(val) => setParams({ ...params, isAM: val })}
              />
            </Col>
          </Row>
        </Col>
        {/* style={{ maxHeight: window.innerHeight - 340, overflowY: "scroll" }} */}
        <Col span={24} >
          <Table
            dataSource={niRatesListData}
            columns={columns}
            size="small"
            // className="aoa-custom-table"
            className="border-top-table"
            locale={{
              triggerDesc: "",
              triggerAsc: "",
              cancelSort: "",
            }}
            // loading={{
            //   spinning: loading,
            //   indicator: (
            //     <Spin
            //       indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />}
            //     />
            //   ),
            // }}
            pagination={{
              defaultPageSize: 15,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
              showSizeChanger: true,
              total: niRatesListData?.length,
              pageSizeOptions: ["15", "25", "50", "100"],
              onChange: (page, pageSize) =>
                setPagination({ current: page, pageSize }),
            }}
            scroll={{ x: 700 }}
          />
        </Col>
      </Row>
    </>
  );
};


export default NIRates